import Image from 'next/image';
import React from 'react';

type VideoPosterProps = {
  poster: string;
};

/**
 * Video poster.
 */
const VideoPoster = (props: VideoPosterProps): JSX.Element => {
  const { poster } = props;
  if (!poster) return <></>;

  return (
    <Image
      fill={true}
      style={{
        top: 0,
        objectFit: 'contain',
      }}
      priority={true}
      fetchPriority="high"
      src={poster}
      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAhGVYSWZNTQAqAAAACAAFARIAAwAAAAEAAQAAARoABQAAAAEAAABKARsABQAAAAEAAABSASgAAwAAAAEAAgAAh2kABAAAAAEAAABaAAAAAAAAAEgAAAABAAAASAAAAAEAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACqADAAQAAAABAAAABgAAAAANsjj3AAAACXBIWXMAAAsTAAALEwEAmpwYAAACM2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+OTczPC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjE3Mjk8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjE8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cm5JfU8AAACFSURBVAgdVY/BDsIwDENfUKtNBSQO7Mb//xcX4MgVxhLcap3AVasmde3YQuAHrtK0Omy9pt4Id8ycnW2t9lRVKjdVQdO36/PG4z5yLAcinHmBy5SZTlm1iF2xDCPnPZT0IvzD7AtDqEFuFPubMd7ykZEUdWgnQqNU643YE7Voa4BGaHrwBYr7NE012bCwAAAAAElFTkSuQmCC"
      placeholder="blur"
      alt=""
    />
  );
};

export default VideoPoster;
